/**
 * AdsManagerTab — single-page entity tree view of the campaign's live publisher state.
 */
import React from 'react';
import { useDispatch } from 'react-redux';
import { Loader } from 'src/components/common/Loader';
import type { AppDispatch } from 'src/store';
import {
  leelaApi,
  usePublisherEntitiesControllerListForCampaignQuery,
} from 'src/store/leela-api';
import { EntitiesView } from './adsManager/EntitiesView';

interface AdsManagerTabProps {
  campaignId: string;
}

export const AdsManagerTab: React.FC<AdsManagerTabProps> = ({ campaignId }) => {
  const dispatch = useDispatch<AppDispatch>();
  const campaignQuery = usePublisherEntitiesControllerListForCampaignQuery({
    campaignId, pageSize: 1, publisher: 'google', publisherEntityType: 'CAMPAIGN',
  });
  const adGroupsQuery = usePublisherEntitiesControllerListForCampaignQuery({
    campaignId, pageSize: 100, publisher: 'google', publisherEntityType: 'AD_GROUP',
  });

  const isLoading = campaignQuery.isLoading || adGroupsQuery.isLoading;
  const isFetching = campaignQuery.isFetching || adGroupsQuery.isFetching;

  const handleRefresh = () => {
    dispatch(leelaApi.util.invalidateTags(['PublisherEntities']));
  };

  return (
    <Loader isLoading={isLoading}>
      <EntitiesView
        adGroupsQuery={adGroupsQuery}
        campaignId={campaignId}
        campaignQuery={campaignQuery}
        isFetching={isFetching}
        onRefresh={handleRefresh}
      />
    </Loader>
  );
};
